module.exports = __webpack_public_path__ + "img/index_reward_second.d0a72223.png";